<script setup lang="ts">
const { data: page } = await useAsyncData(useRoute().path, () => queryCollection('content').path(useRoute().path).first())

useSeoMeta({
  title: page.value.seo.title,
  description: page.value.seo.description,
})
</script>

<template>
  <UPageHero v-bind="page.meta.hero" align="center"/>
  <UPageSection :ui="{container: 'lg:py-0'}">
    <template #description>
      <div class="text-sm text-center flex flex-col items-center">
        <MDC :value="page.meta.infos" class="max-w-lg" />
      </div>
    </template>

    <SubscriptionPlans id="pricing"/>
  </UPageSection>
  <SectionManager :sections="page.meta.sections" />
</template>